import { SearchBarType } from "@/constant/SearchBarType";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import dayjs from "dayjs";
import type { Dayjs } from "dayjs";

export const getInvoiceOperateSearchConfig = () => {
  const t = getTranslateNsT("invoice");
  return [
    {
      type: SearchBarType.Input,
      field: "payRecordId",
      label: t("invoice_record_header_id"),
      commponentProps: {
        placeholder: t("invoice_transaction_number_placholder"),
        style: { width: "240px" },
      },
    },
    {
      type: SearchBarType.DatePicker,
      field: "startTime",
      label: t("invoice_recharge_time"),
      commponentProps: {
        disabledDate: (current: Dayjs) => {
          return (
            current &&
            (current > dayjs().endOf("days") ||
              current < dayjs().subtract(1, "year"))
          );
        },
      },
    },
  ];
};

export const getInvoiceRecordSearchConfig = () => {
  const t = getTranslateNsT("invoice");
  return [
    {
      type: SearchBarType.DatePicker,
      field: "startTime",
      label: t("invoice_biling_time"),
    },
  ];
};
